module.exports = __webpack_public_path__ + "static/media/htmlcssjs.0bd486e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/frontend/htmlcssjs.png
// module id = 1530
// module chunks = 0